import React from 'react';
export function QuestionMarkIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20a1 1 0 100-2 1 1 0 000 2zM12 17a1 1 0 01-1-1v-2a4.18 4.18 0 012.33-3.79l.44-.23A2.2 2.2 0 0015 8a3 3 0 00-.88-2.12 3.07 3.07 0 00-4.24 0A3 3 0 009 8a1 1 0 01-2 0 5 5 0 018.53-3.53A4.94 4.94 0 0117 8a4.2 4.2 0 01-2.33 3.78l-.44.22A2.22 2.22 0 0013 14v2a1 1 0 01-1 1z"
  }));
}